import styled from 'styled-components';

export const CardContainer = styled.div`
  background: ${({ theme }) => theme.colors.background};
`;

/**
 * Mirrors the `HeaderSection` pattern used by other modern map
 * cards (`PureWirelessCard`, `SpatialLayerCardContainer`'s nested
 * `StyledMapCardHeader`): bottom border + 12/13px padding. Extra
 * right padding leaves room for the absolutely-positioned close
 * button rendered by `MapCard` at `top: 16, right: 16` so the title
 * never collides with the X.
 */
export const HeaderSection = styled.div`
  padding: 12px 16px 12px 13px;
  padding-right: 40px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.heavyLineOutline};
`;

/**
 * Horizontal padding around the RAD-e body so EllingtonCard content
 * is inset from the card edges. Matches the 13px gutter used by
 * `PureWirelessCard`'s `BorderedSection`.
 */
export const BodySection = styled.div`
  padding: 12px 13px;
`;
